/**
 * bz-exam-city.js
 * Exam-season city LP — JavaScript.
 * Mirrors bz-gaba-precursor-guide.js patterns throughout.
 * Lane: exam_season_2026_q2 (PRO primary, ELITE secondary, NO ORIGINAL).
 * Created: 2026-04-27 — Wave-5 exam-season build.
 */

/* Product shelf is now rendered by the shared bz-component-shelf.liquid snippet.
   See snippets/bz-shelf-data.liquid for product data + renderer IIFE. */


/* ─────────────────────────────────────────────────────────────────────
   3. STUDY WEEK PLANNER — tab switching
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.bz-ec-planner__tab');
    var panels = document.querySelectorAll('.bz-ec-planner__panel');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('active'); });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        var target = tab.getAttribute('data-tab');
        var panel = document.querySelector('.bz-ec-planner__panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   4. ACCORDION — shared pattern (mirrors bz-gaba-precursor-guide.js)
   ───────────────────────────────────────────────────────────────────── */

/* toggleAccordion may already be defined by GABA guide on shared pages.
   Guard with typeof check to avoid double-define. */
/* toggleAccordion — unified pattern (matches adhd-supplements-guide.js).
   Guard with typeof check to avoid double-define on shared pages. */
if (typeof toggleAccordion === 'undefined') {
  function toggleAccordion(btn) { /* eslint-disable-line no-unused-vars */
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', !expanded);
    var panel = btn.nextElementSibling;
    var item = btn.closest('.accordion-item');
    if (expanded) {
      panel.style.maxHeight = null;
      btn.querySelector('.accordion-chevron').textContent = '+';
      if (item) item.classList.remove('open');
    } else {
      if (item) item.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
      btn.querySelector('.accordion-chevron').textContent = '−';
    }
  }
}

/* ─────────────────────────────────────────────────────────────────────
   5. PROGRESS BAR + STICKY CTA (exam lane)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    /* Exam-lane sticky CTA messages */
    var MESSAGES = [
      { pct: 0.05, text: 'Pflanzlich, hergestellt in Schottland', label: 'FOCUS PRO testen — Code WILLKOMMEN10', url: '#produkt-auswaehlen' },
      { pct: 0.25, text: 'Von über 2.000 medizinischen Fachleuten empfohlen', label: 'FOCUS PRO testen — €31,75', url: '#produkt-auswaehlen' },
      { pct: 0.50, text: '365-Tage-Geld-zurück-Garantie', label: 'FOCUS PRO risikofrei testen', url: '#produkt-auswaehlen' },
      { pct: 0.70, text: 'Über 6.020 verifizierte Bewertungen', label: 'FOCUS ELITE testen — €52', url: '#produkt-auswaehlen' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';

      if (cta) {
        cta.classList.toggle('visible', pct > 0.08 && pct < 0.96);
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   6. ANIMATED STAT COUNTERS (reuses existing [data-target] pattern)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var start = 0; void start; /* unused but mirrors existing pattern */
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();
